import { Button, Container, Grid, Paper, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { url } from "../../baseUrl";
import DatatablePage from "../../Components/DataTable/DataTable";
import CustomizedSnackbars from "../../Components/SnackBar/SnackBar";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {
  brandName,
  darkButton,
  lightBackground,
  lightText,
  white,
} from "../../Assets/Theme/ThemeColors";
import { useSelector } from "react-redux";
import Navbar from "../../Components/Navbar/Navbar";
import RefreshIcon from "@mui/icons-material/Refresh";

// ========== NEW COLOR PALETTE (PURPLE THEME) ==========
const colors = {
  primary: "#6d28d9",      // Purple
  primaryDark: "#4c1d95",  // Darker purple
  primaryLight: "#ede9fe", // Light purple
  background: "#f5f3ff",   // Very light purple
  white: "#ffffff",
  textPrimary: "#1a1a2e",
  success: "#16a34a",      // Green for paid
  danger: "#dc2626",       // Red for unpaid
};

const TransactionList = () => {
  const user = useSelector((state) => state.user.data);

  console.log("user", user);

  const [data, setData] = useState();
  const [isLoaded, setIsLoaded] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  let navigate = useNavigate();

  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "GBP",
  });

  const columns = [
    {
      label: "Action",
      field: "action",
      sort: "asc",
      width: 100,
    },
    {
      label: "Year",
      field: "year",
      sort: "asc",
      width: 100,
    },
    {
      label: "Month",
      field: "month",
      sort: "asc",
      width: 100,
    },
    {
      label: "Date",
      field: "dateTime",
      sort: "asc",
      width: 200,
    },
    {
      label: "Customer Name",
      field: "custName",
      sort: "asc",
      width: 250,
    },
    {
      label: "Email Address",
      field: "custEmail",
      sort: "asc",
      width: 250,
    },
    {
      label: "Phone Number",
      field: "custContactNumber",
      sort: "asc",
      width: 250,
    },
    {
      label: "Brand",
      field: "brand",
      sort: "asc",
      width: 150,
    },
    {
      label: "Order ID",
      field: "orderId",
      sort: "asc",
      width: 150,
    },
    {
      label: "Type Of Sale",
      field: "saleType",
      sort: "asc",
      width: 150,
    },
    {
      label: "Sale's Person",
      field: "salePerson",
      sort: "asc",
      width: 250,
    },
    {
      label: "Service",
      field: "detailDiscription",
      sort: "asc",
      width: 150,
    },
    {
      label: "Total Amount",
      field: "total",
      sort: "asc",
      width: 100,
    },
    {
      label: "Account",
      field: "account",
      sort: "asc",
      width: 100,
    },
    {
      label: "Payment Status",
      field: "paymentStatus",
      sort: "asc",
      width: 100,
    },
    {
      label: "Payment Time",
      field: "paymentTime",
      sort: "asc",
      width: 100,
    },
    {
      label: "Description",
      field: "discription",
      sort: "asc",
      width: 150,
    },
    {
      label: "Invoice-Link",
      field: "invoiceLink",
      sort: "asc",
      width: 300,
    },
    {
      label: "Stripe ID",
      field: "stripeId",
      sort: "asc",
      width: 150,
    },
  ];

  useEffect(() => {
    getAllTransactions();
  }, []);

  const getAllTransactions = async () => {
    try {
      setData([]);
      setIsLoaded(true);
      await axios
        .post(
          `${url}/transactions/getAllTransactions`,
          { brand: brandName },
          {
            headers: {
              Authorization: `Bearer ${user.token}`,
            },
          }
        )
        .then((response) => {
          console.log("data", response.data.data);

          setData({
            columns,
            rows: response.data.data.map((item) => ({
              ...item,
              total: formatter.format(item.total),
              paymentStatus: item.paymentStatus ? (
                <Typography
                  variant="button"
                  style={{
                    padding: "6px 14px",
                    background: colors.success,
                    borderRadius: "20px",
                    color: colors.white,
                    fontWeight: 600,
                    fontSize: "12px",
                  }}
                >
                  Paid
                </Typography>
              ) : (
                <Typography
                  variant="button"
                  style={{
                    padding: "6px 14px",
                    background: colors.danger,
                    borderRadius: "20px",
                    color: colors.white,
                    fontWeight: 600,
                    fontSize: "12px",
                  }}
                >
                  Unpaid
                </Typography>
              ),
              paymentTime: item.paymentStatus
                ? new Date(item.updatedAt).toLocaleString("en-US", {
                    timeZone: "Asia/Karachi",
                  })
                : "",
              action: (
                <span
                  onClick={() =>
                    navigate(`/transaction/record/${item._id}_readOnly`)
                  }
                  style={{
                    color: colors.primary,
                    cursor: "pointer",
                  }}
                  title="View"
                >
                  <RemoveRedEyeIcon />
                </span>
              ),
            })),
          });
          setIsOpen(true);
          setMessage("Data Loaded!");
          setSeverity("success");
          setIsLoaded(false);
        });
    } catch (error) {
      console.log("error", error.message);
      setIsLoaded(false);
      setIsOpen(true);
      setMessage(error.message);
      setSeverity("error");
    }
    setTimeout(() => {
      setIsOpen(false);
    }, 2000);
  };

  return (
    <>
      <Navbar />

      <Container
        style={{
          maxWidth: "100%",
          padding: "0px",
          overflowY: "scroll",
          height: "94vh",
          background: colors.background, // <-- New background
        }}
      >
        <Paper
          fullWidth
          sx={{
            m: 1,
            p: 2,
            maxWidth: "100%",
            backgroundColor: colors.white,
            borderRadius: "16px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
          }}
        >
          <Grid style={{ display: "flex", justifyContent: "flex-start" }}>
            <Typography
              variant="h5"
              style={{ color: colors.textPrimary, fontWeight: 700 }}
            >
              All Transactions
            </Typography>
          </Grid>

          <Grid
            xs={12}
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 16,
            }}
          >
            <Button
              onClick={getAllTransactions}
              variant="contained"
              style={{
                background: colors.primary,
                color: colors.white,
                borderRadius: "12px",
                padding: "10px 20px",
                fontWeight: 600,
                textTransform: "none",
                boxShadow: "0 4px 12px rgba(109,40,217,0.3)",
                display: "flex",
                alignItems: "center",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.background = colors.primaryDark)
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.background = colors.primary)
              }
            >
              <RefreshIcon sx={{ mr: 1 }} />
              Reload
            </Button>

            <Button
              onClick={() =>
                navigate(`/transaction/record/00000000000_CREATE`)
              }
              variant="contained"
              style={{
                background: colors.primary,
                color: colors.white,
                borderRadius: "12px",
                padding: "10px 20px",
                fontWeight: 600,
                textTransform: "none",
                boxShadow: "0 4px 12px rgba(109,40,217,0.3)",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.background = colors.primaryDark)
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.background = colors.primary)
              }
            >
              Generate New Link
            </Button>
          </Grid>

          {/* Table intact – not removed */}
          <DatatablePage data={data} isLoaded={isLoaded} />
        </Paper>
      </Container>

      <CustomizedSnackbars
        isOpen={isOpen}
        severity={severity}
        message={message}
      />
    </>
  );
};

export default TransactionList;